// REDUX ACTION TYPES
export const PRODUCT_LIST = "PRODUCT_LIST";
export const PRODUCT_LIST_PAGE = "PRODUCT_LIST_PAGE";
export const SET_IS_LOADING = "SET_IS_LOADING";
export const PRODUCT_LIST_METADATA = "PRODUCT_LIST_METADATA";
export const CATEGORIES_LIST = "CATEGORIES_LIST";
export const PRODUCT_DETAILS = "PRODUCT_DETAILS";
export const PRODUCT_DETAILS_ERROR = "PRODUCT_DETAILS_ERROR";
export const SELECTED_COLOR = "SELECTED_COLOR";
export const SELECTED_STORAGE = "SELECTED_STORAGE";
export const SELECTED_VARIANT = "SELECTED_VARIANT";
export const ADD_COMPARE_PRODUCT = "ADD_COMPARE_PRODUCT";
export const REMOVE_COMPARE_PRODUCT = "REMOVE_COMPARE_PRODUCT";
export const SHOW_COMPARE_ERROR = "SHOW_COMPARE_ERROR";
export const REMOVE_ALL = "REMOVE_ALL";
export const PRODUCT_COMPARE_LIST = "PRODUCT_COMPARE_LIST";
export const REPLACE_COMPARE_PRODUCT = "REPLACE_COMPARE_PRODUCT";
export const PRODUCT_SEARCH_LIST = "PRODUCT_SEARCH_LIST";
export const GET_SKU = "GET_SKU";
export const MEGA_MENU = "MEGA_MENU";
export const GLOBAL_NAV = "GLOBAL_NAV";
export const SET_HOME_COMPONENTS = "SET_HOME_COMPONENTS";
export const SELECT_CATEGORY = "SELECT_CATEGORY";
export const SELECT_SUB_CATEGORY = "SELECT_SUB_CATEGORY";
export const SELECT_BRANDS = "SELECT_BRANDS";
export const SELECT_PRICE = "SELECT_PRICE";
export const SELECT_PROMOTIONS = "SELECT_PROMOTIONS";
export const RESET_FILTERS = "RESET_FILTERS";
export const TOGGLE_FILTERS = "TOGGLE_FILTERS";
export const SELECT_PRODUCT_RANGE = "SELECT_PRODUCT_RANGE";
export const PAGE_HISTORY = "PAGE_HISTORY";
export const GEOLOCATION_STATUS = "GEOLOCATION_STATUS";
export const GEOLOCATION_POSITION = "GEOLOCATION_POSITION";
export const CANDC_STORE_DETAILS = "CANDC_STORE_DETAILS";
export const GET_FOOTER_LINKS_SUCCESS = "GET_FOOTER_LINKS_SUCCESS";
export const GET_FOOTER_LINKS_FAILURE = "GET_FOOTER_LINKS_FAILURE";
export const DISPLAY_HIDE_FOOTER = "DISPLAY_HIDE_FOOTER";
export const TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS";
export const CHANGE_OTHER_METHODS = "CHANGE_OTHER_METHODS";
export const CHANGE_OTHER_STORE = "CHANGE_OTHER_STORE";
export const TERMS_AND_CONDITIONS_TOPIC = "TERMS_AND_CONDITIONS_TOPIC";
export const UPDATE_PRODUCT_BRANDS = "UPDATE_PRODUCT_BRANDS";
export const ADD_SIMPLE_PRODUCT_TO_CART = "ADD_SIMPLE_PRODUCT_TO_CART";
export const ADD_BUNDLE_PRODUCT_TO_CART = "ADD_BUNDLE_PRODUCT_TO_CART";
export const ADD_CONFIGURABLE_PRODUCT_TO_CART =
  "ADD_CONFIGURABLE_PRODUCT_TO_CART";
export const UPDATE_CART = "UPDATE_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const GUEST_VIEW_CART = "GUEST_VIEW_CART";
export const GUEST_RESET_CART = "GUEST_RESET_CART";
export const SET_SHIPPING_METHOD = "SET_SHIPPING_METHOD";
export const SET_SHIPPING = "SET_SHIPPING";
export const SET_BILLING = "SET_BILLING";
export const ADD_COUPON_CODE = "ADD_COUPON_CODE";
export const REMOVE_COUPON_CODE = "REMOVE_COUPON_CODE";
export const SET_PROFILE_DATA = "SET_PROFILE_DATA";
export const SET_PROFILE_LOADING = "SET_PROFILE_LOADING";
export const SET_RELOGIN = "SET_RELOGIN";
export const SET_MINIAPP = "SET_MINIAPP";
export const SET_BACKENABLED = "SET_BACKENABLED";
export const SET_CHECKOUT_LOGIN = "SET_CHECKOUT_LOGIN";
export const TOGGLE_SEARCH = "TOGGLE_SEARCH";
export const BREADCRUMB_SELECT = "BREADCRUMB_SELECT";
export const ALERT_SELECT = "ALERT_SELECT";
export const GET_SHIPPING_BILLING = "GET_SHIPPING_BILLING";
export const IS_MULTICART = "IS_MULTICART";

export const SET_NORMAL_CHECKOUT_CURRENT_STEP =
  "SET_NORMAL_CHECKOUT_CURRENT_STEP";
export const SET_POST_CHECKOUT_CURRENT_STEP = "SET_POST_CHECKOUT_CURRENT_STEP";
export const SET_LOOKUP_DETAILS = "SET_LOOKUP_DETAILS";
export const SET_AUTHENTICATION_DETAILS = "SET_AUTHENTICATION_DETAILS";
export const SET_SKIP_CREDIT_VETTING = "SET_SKIP_CREDIT_VETTING";
export const SET_XDS_RESULT = "SET_XDS_RESULT";
export const SET_CREDIT_VETTING_RESULT = "SET_CREDIT_VETTING_RESULT";
export const SET_NUMBER_TRANSFER_TYPE = "SET_NUMBER_TRANSFER_TYPE";
export const SET_NUMBER_TO_TRANSFER = "SET_NUMBER_TO_TRANSFER";
export const SET_NUMBER_TRANSFER_DETAILS = "SET_NUMBER_TRANSFER_DETAILS";
export const SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD";
export const SET_PAYMENT_METHOD_URL = "SET_PAYMENT_METHOD_URL";
export const SET_POST_ORDER_RESPONSE = "SET_POST_ORDER_RESPONSE";

// upgrade
export const DISPLAY_HIDE_MODAL = "DISPLAY_HIDE_MODAL";
export const TOP_BANNER_TOGGLE = "TOP_BANNER_TOGGLE";
export const TOP_BANNER_MODAL_TOGGLE = "TOP_BANNER_MODAL_TOGGLE";
export const STOP_UPGRADE_MODAL_TOGGLE = "STOP_UPGRADE_MODAL_TOGGLE";
export const UPDATE_UPGRADE_JOURNEY_STATUS = "UPDATE_UPGRADE_JOURNEY_STATUS";
export const CLEAR_UPGRADE_JOURNEY_STATUS = "CLEAR_UPGRADE_JOURNEY_STATUS";
export const UPDATE_CAN_RECEIVE_OTP = "UPDATE_CAN_RECEIVE_OTP";
export const UPDATE_MSISDN_STATUS = "UPDATE_MSISDN_STATUS";
export const UPDATE_ELIGIBILITY_CHECK_STATUS =
  "UPDATE_ELIGIBILITY_CHECK_STATUS";
export const UPDATE_DISPLAY_DATA = "UPDATE_DISPLAY_DATA";
export const UPDATE_SELECTED_DISPLAY_DATA = "UPDATE_SELECTED_DISPLAY_DATA";
export const UPDATE_UPGRADE_DATA = "UPDATE_UPGRADE_DATA";
export const INVALID_OTP = "INVALID_OTP";
export const UPDATE_ELIGIBILITY_DATA = "UPDATE_ELIGIBILITY_DATA";
export const ADD_ALTERNATE_NUMBERS = "ADD_ALTERNATE_NUMBERS";
export const SET_CREDIT_CHECK_PERSONAL_DATA = "SET_CREDIT_CHECK_PERSONAL_DATA";
export const SET_CREDIT_CHECK_EMPLOYMENT_DATA =
  "SET_CREDIT_CHECK_EMPLOYMENT_DATA";
export const SET_CREDIT_CHECK_HOME_DATA = "SET_CREDIT_CHECK_HOME_DATA";
export const SET_CREDIT_CHECK_DEBIT_DATA = "SET_CREDIT_CHECK_DEBIT_DATA";
export const SET_CREDIT_CHECK_DELIVERY_DATA = "SET_CREDIT_CHECK_DELIVERY_DATA";
export const SET_CREDIT_CHECK_CONTACT_DATA = "SET_CREDIT_CHECK_CONTACT_DATA";
export const SET_CREDIT_CHECK_AFFORD_DEAL = "SET_CREDIT_CHECK_AFFORD_DEAL";
export const SET_CREDIT_SELECTED_AFFORD_DEAL =
  "SET_CREDIT_SELECTED_AFFORD_DEAL";
export const UPDATE_LOGGED_IN_USER_ELIGIBILITY_DATA =
  "UPDATE_LOGGED_IN_USER_ELIGIBILITY_DATA";
export const UPDATE_UNMASKED_MSISDN = "UPDATE_UN_MASKED_MSISDN";
export const GET_PAST_USAGE = "GET_PAST_USAGE";
export const GET_UPGRADE_BRANDS = "GET_UPGRADE_BRANDS";
export const GET_UPGRADE_MODELS = "GET_UPGRADE_MODELS";
export const GET_RECOMMENDED_DEALS = "GET_RECOMMENDED_DEALS";
export const UPDATE_SELECTED_UPGRADE_DATA = "UPDATE_SELECTED_UPGRADE_DATA";
export const UPDATE_UPGRADE_REDIRECT = "UPDATE_UPGRADE_REDIRECT";
export const GET_UPGRADE_CONSUMPTION = "GET_UPGRADE_CONSUMPTION";
export const ADD_CREDIT_PROFILE = "ADD_CREDIT_PROFILE";
export const UPDATE_CHECK_DEAL_QUALIFIES = "UPDATE_CHECK_DEAL_QUALIFIES";
export const STOP_UPGRADE = "STOP_UPGRADE";
export const RESET_INVALID_OTPS = "RESET_INVALID_OTPS";
export const TOGGLE_SNACK_BAR = "TOGGLE_SNACK_BAR";
export const DEAL_PRICE = "DEAL_PRIC";
export const PAST_TOKEN = "PAST_TOKEN";
export const UPDATE_DEAL_GRID_RESET = "UPDATE_DEAL_GRID_RESET";
export const UPDATE_DEAL_SELECTION_RESET = "UPDATE_DEAL_SELECTION_RESET";
export const UPDATE_PRODUCT_GRID_RESET = "UPDATE_PRODUCT_GRID_RESET";
export const UPDATE_LINKED_NUMBER = "UPDATE_LINKED_NUMBER";
export const MSISDN_BLOCKED = "MSISDN_BLOCKED";
export const DISPLAY_INVALID_OTP_ERROR = "DISPLAY_INVALID_OTP_ERROR";
export const UPDATE_NEXT_MSISDN_SELECTED = "UPDATE_NEXT_MSISDN_SELECTED";
export const CLEAR_ENTIRE_JOURNEY = "CLEAR_ENTIRE_JOURNEY";
export const ADD_DEAL_TO_CART = "ADD_DEAL_TO_CART";
export const SET_CREDIT_VETTING_OUTCOME = "SET_CREDIT_VETTING_OUTCOME";

export const SYNC_USER_PROFILE = "SYNC_USER_PROFILE";
export const SYNC_USER_PROFILE_SUCCESS = "SYNC_USER_PROFILE_SUCCESS";
export const SYNC_USER_PROFILE_FAILURE = "SYNC_USER_PROFILE_FAILURE";
export const SYNC_USER_PROFILE_RESET = "SYNC_USER_PROFILE_RESET";

//post-checkout
export const GUEST_CART_ITEMS = "GUEST_CART_ITEMS";

//checkout-page-error
export const CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE =
  "CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE";

//help button
export const SET_HELP_LEAD_BUCKET = "SET_HELP_LEAD_BUCKET";

// Deal Details
export * as DealDetailsActionTypes from "./dealDetailsActionTypes";

// Features
export const SET_FEATURES = "SET_FEATURES";

// Page Builder
export const GET_CATEGORY_CMS_CONTENT = "GET_CATEGORY_CMS_CONTENT";
export const GET_DEALS_PRODUCTS_BY_SKUS = "GET_DEALS_PRODUCTS_BY_SKUS";
export const GET_PRODUCTS_BY_SKUS = "GET_PRODUCTS_BY_SKUS";
export const GET_CURRENCY_SYMBOL = "GET_CURRENCY_SYMBOL";

// Deal Builder
export const SET_CONTRACT_MODE = "SET_CONTRACT_MODE";
export const SET_MAX_RECURRING = "SET_MAX_RECURRING";
